'use strict';

import {ClientEventType} from "../../../services/client-events/models/ClientEventType";

{
    angular.module('tf.portfolio.ticket')
        .controller('ticketEquityCtrl', ['$scope', '$http', '$uibModalInstance', '$stateParams', '$interval', 'userConfig', function ticketEquityController($scope, $http, $uibModalInstance, $stateParams, $interval, userConfig) {

            $scope.isShowOrder = true;

            $scope.showOrders = function() {
                $scope.isShowOrder = true;
                $scope.isShowConfo = false;
            };

            $scope.showConfo = function() {
                $scope.isShowOrder = false;
                $scope.isShowConfo = true;
            };

            $scope.qtyShares = true;

            $scope.toggleQtyType = function() {
                $scope.qtyShares = !$scope.qtyShares;
            }

            $scope.qtyValue = 0;
        }])
        .controller('ticketMultiAccountEquityCtrl', ['$scope', '$http', '$uibModalInstance', '$stateParams', '$interval', 'userConfig', function ticketEquityController($scope, $http, $uibModalInstance, $stateParams, $interval, userConfig) {

            $scope.isShowOrder = true;

            $scope.showOrders = function() {
                $scope.isShowOrder = true;
                $scope.isShowConfo = false;
            };

            $scope.showConfo = function() {
                $scope.isShowOrder = false;
                $scope.isShowConfo = true;
            };

            $scope.qtyShares = true;

            $scope.toggleQtyType = function() {
                $scope.qtyShares = !$scope.qtyShares;
            }

            $scope.qtyValue = 0;
        }])


        .controller('ticketCollateralCtrl',
            ['$scope', '$http', '$uibModalInstance', 'trades', '$stateParams', '$interval', 'growl', 'collateral', "clientEventService",
                function ($scope, $http, $uibModalInstance, trades, $stateParams, $interval, growl, collateral, clientEventService) {

            // $scope.trades = trades;
            $scope.trades = trades.map(function(t) {
                var trade = {
                    maxSellQty : 0,
                    quantity : t.quantity,
                    issuer : t.issuer
                };
                for (var i = 0; i < collateral.length; i++) {
                    if (collateral[i].issuer == trade.issuer) {
                        trade.maxSellQty = collateral[i].quantity;
                    }
                }
                return trade;
            });

            $scope.swapSide = function(trade) {
                if (trade.quantity) {
                    trade.quantity = -trade.quantity;
                }
                $scope.tradeQtyChanged(trade);
            };

            $scope.linkTrade = function(trade) {
                trade.linked = !trade.linked
            };

            $scope.setLimit = function(trade, limit) {
                trade.limit = limit;
            };

            $scope.ordersConfirmed = true;


            const sub = clientEventService.events()
                                          .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                          .subscribe(() => updateBidAsk());

            $scope.$on("$destroy", () => sub.unsubscribe());

            updateBidAsk();

            $scope.tradeQtyChanged = function(trade) {
                if (trade.quantity < -trade.maxSellQty) {
                    trade.quantity = -trade.maxSellQty;
                }
            };

            function removeTrade(trade) {
                $scope.trades = $scope.trades.filter(function (t) {
                    return t != trade;
                });
            }

            function placeOrder(buy, trade) {

                var quantity = buy ? Math.abs(trade.quantity) : -Math.abs(trade.quantity);
                var price = buy ? trade.spread.ask : trade.spread.bid;
                var trades = [];

                var equityTrade = {
                    quantity : quantity,
                    price : price,
                    issuer : trade.issuer
                };
                trades.push(equityTrade);

                return $http.put('/tradefloor/api/portfolio/' + $stateParams.portfolioId + '/ticket/pre/equity', trades)
                    .then(function(response){
                        if (response.status === 200) {
                            $scope.causesShortage = false;
                            if (equityTrade.quantity < 0) {
                                if (equityTrade.id == null) {
                                    equityTrade.id = $scope.equityCollateral
                                }
                                //map into new object rather than mess with this one

                                if (equityTrade.id == null) {
                                    for (var i = 0; i < collateral.length; i++) {
                                        if (collateral[i].issuer == equityTrade.issuer) {
                                            equityTrade.id = collateral[i].id;
                                        }
                                    }
                                }
                                return $http.delete("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/equity/" + equityTrade.id + "/" + equityTrade.quantity + "/" + equityTrade.price).then(function(response) {
                                    var orderDescription = (buy ? 'Buy' : 'Sell') + ' ' + Math.abs(equityTrade.quantity) + ' ' + equityTrade.issuer;

                                    if (response.status === 200) {
                                        growl.success(orderDescription + ' placed', {title : 'Order placed'});
                                        $uibModalInstance.close();
                                    } else if (response.status === 204) {
                                        growl.error('Unable to place ' + orderDescription + '. Market orders can be placed between <b>10:40am</b> and <b>4:00pm</b> AEST.', {title : 'Market is closed.'});
                                    }

                                });
                            } else {
                                return $http.put("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/equity", equityTrade).then(function(response) {
                                    var orderDescription = (buy ? 'Buy' : 'Sell') + ' ' + Math.abs(equityTrade.quantity) + ' ' + equityTrade.issuer;

                                    if (response.status === 200) {
                                        growl.success(orderDescription + ' placed', {title : 'Order placed'});
                                        $uibModalInstance.close();
                                    } else if (response.status === 204) {
                                        growl.error('Unable to place ' + orderDescription + '. Market orders can be placed between <b>10:40am</b> and <b>4:00pm</b> AEST.', {title : 'Market is closed.'});
                                    }

                                });
                            }
                        }
                        if (response.status === 204) {
                            $scope.causesShortage = true;
                        }


                    });


            }

            $scope.invalidQty = false;

            $scope.placeSingleOrder = function(buy, trade) {
                // TODO we need to stop duplicate submissions by locking the trade
                if (trade.quantity == 0) {
                    $scope.invalidQty = true;
                } else {
                    $scope.invalidQty = false;
                    placeOrder(buy, trade).then(closeIfNoTrades);
                }
            };

            $scope.placeAllOrders = function () {
                // TODO disable the place all button while this is executing
                $scope.trades.forEach(function(trade) {
                    if (!trade.quantity || trade.quantity == 0) {
                        $scope.invalidQty = true;
                    } else {
                        $scope.invalidQty = false;
                        $scope.placeSingleOrder(trade.quantity >= 0, trade);
                    }
                });
            };

            $scope.removeTrade = function(trade) {
                removeTrade(trade);
                closeIfNoTrades();
            };

            $scope.cancel = function () {
                $uibModalInstance.close();
            };

            function updateBidAsk() {
                var codes = trades.map(function (t) {
                    return t.issuer
                }).join(',');

                return $http.post('/tradefloor/api/order/spread', codes).then(function(response){
                    var data = response.data;
                    for (var j = 0; j < $scope.trades.length; j++) {
                        for (var k = 0; k < data.bidAskSummaryList.length; k++) {
                            if ($scope.trades[j].issuer == data.bidAskSummaryList[k].code) {
                                $scope.trades[j].spread = data.bidAskSummaryList[k];
                            }
                        }
                    }
                })
            };

            function closeIfNoTrades() {
                if (!$scope.trades.length) {
                    $uibModalInstance.close();
                }
            }
        }]);

}
